/*
 * Wish Dance — UX LAB (31 agosto 2026)
 * Tre interventi, nessuna libreria, tutto degradabile.
 *
 *   1) impulso sul carrello quando qualcosa ci entra
 *      Dalla griglia l'aggiunta non dava alcun segnale visivo.
 *   2) scorciatoia dalla ricerca ai filtri
 *      "scarpe nere 38" restituiva 1.000 risultati: la ricerca Shopify non
 *      sa nulla di colore e taglia, ma i metafield custom.colore_base e
 *      custom.taglie li conoscono entrambi.
 *   3) taglie della scheda rivelate al passaggio del mouse
 *      (il markup lo produce snippets/wd-card-sizes.liquid)
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================================
     1. Impulso sul carrello
     ================================================================ */
  function cartPulse() {
    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (!icon || reduce) return;
    icon.classList.remove('wd-cart-pulse');
    void icon.offsetWidth;
    icon.classList.add('wd-cart-pulse');
    setTimeout(function () { icon.classList.remove('wd-cart-pulse'); }, 600);
  }

  // Il tema aggiorna il carrello via fetch su /cart/add: si ascolta la
  // risposta invece di agganciarsi ai singoli pulsanti, che sono molti e
  // vengono ricreati a ogni ricarico AJAX della griglia.
  (function watchCartAdds() {
    if (!window.fetch) return;
    var original = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      var promise = original.apply(this, arguments);
      if (href.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) cartPulse();
          return res;
        }).catch(function () { /* l'errore lo gestisce il tema */ });
      }
      return promise;
    };
  })();

  /* ================================================================
     2. Dalla ricerca ai filtri
     ----------------------------------------------------------------
     Solo un suggerimento sopra i risultati: non reindirizza da solo,
     non tocca la ricerca del tema, non rompe nulla se i metafield
     cambiano nome (in quel caso il link semplicemente non compare
     perche non si trova alcun termine).
     ================================================================ */

  // I 17 valori reali di custom.colore_base, con le forme in cui la gente
  // li scrive davvero (femminile, maschile, plurale).
  var COLORI = {
    'Nero': ['nero', 'nera', 'neri', 'nere', 'black'],
    'Bianco': ['bianco', 'bianca', 'bianchi', 'bianche', 'white'],
    'Rosso': ['rosso', 'rossa', 'rossi', 'rosse', 'red'],
    'Oro': ['oro', 'dorato', 'dorata', 'gold', 'dorate'],
    'Argento': ['argento', 'argentato', 'argentata', 'silver'],
    'Nude': ['nude', 'cipria', 'carne', 'beige', 'sabbia'],
    'Bordeaux': ['bordeaux', 'bordò', 'burgundy', 'burdeos'],
    'Rosa': ['rosa', 'pink'],
    'Blu': ['blu', 'blue', 'azzurro', 'azzurra'],
    'Verde': ['verde', 'verdi', 'green'],
    'Marrone': ['marrone', 'marroni', 'testa di moro', 'brown', 'marrón'],
    'Grigio': ['grigio', 'grigia', 'grigi', 'grigie'],
    'Viola': ['viola', 'lilla', 'glicine'],
    'Giallo': ['giallo', 'gialla', 'gialle'],
    'Arancione': ['arancione', 'arancio'],
    'Bronzo': ['bronzo', 'rame'],
    'Multicolore': ['multicolore', 'fantasia', 'stampa', 'leopardo', 'animalier']
  };

  var DISCIPLINE = {
    'Salsa': ['salsa'],
    'Bachata': ['bachata'],
    'Kizomba': ['kizomba'],
    'Tango': ['tango'],
    'Latino americano': ['latino', 'latino americano', 'caraibico'],
    'Danze standard': ['standard', 'liscio'],
    'Danza classica': ['classica', 'punte', 'balletto'],
    'Danze Sportive': ['competizione', 'gara', 'sportive', 'competition'],
    'Jazz e moderno': ['jazz', 'moderno', 'modern'],
    'Cerimonia': ['cerimonia', 'sposa', 'wedding', 'boda']
  };

  function trovaTermine(mappa, testo) {
    var trovato = null;
    Object.keys(mappa).forEach(function (chiave) {
      if (trovato) return;
      mappa[chiave].forEach(function (alias) {
        if (trovato) return;
        // Confine di parola: "oro" non deve scattare dentro "lavoro".
        var re = new RegExp('(^|[^a-zà-ù])' + alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-zà-ù]|$)', 'i');
        if (re.test(testo)) trovato = chiave;
      });
    });
    return trovato;
  }

  function trovaTaglia(testo) {
    // Taglie scarpa adulte e da bambino: 21-48. Un numero fuori da questo
    // intervallo (un prezzo, un codice modello) non e una taglia.
    var m = testo.match(/(^|[^0-9])([2-4][0-9])([^0-9,.]|$)/);
    if (!m) return null;
    var n = parseInt(m[2], 10);
    return n >= 21 && n <= 48 ? String(n) : null;
  }

  function suggerisciFiltri() {
    // /en/search e /es/search: il prefisso di lingua viene prima di /search.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (location.pathname.replace(/\/$/, '') !== root.replace(/\/$/, '') + '/search') return;
    var lang = (document.documentElement.lang || 'it').slice(0, 2);
    var T = {
      it: { ask: 'Cerchi ', size: 'taglia ', see: 'Vedi solo questi ' },
      en: { ask: 'Looking for ', size: 'size ', see: 'Show only these ' },
      es: { ask: '¿Buscas ', size: 'talla ', see: 'Ver solo estos ' },
      fr: { ask: 'Vous cherchez ', size: 'taille ', see: 'Voir seulement ceux-ci ' },
      de: { ask: 'Suchst du ', size: 'Größe ', see: 'Nur diese anzeigen ' }
    }[lang] || { ask: 'Cerchi ', size: 'taglia ', see: 'Vedi solo questi ' };

    var q = new URLSearchParams(location.search).get('q');
    if (!q || q.length < 3) return;

    var testo = ' ' + q.toLowerCase() + ' ';
    var colore = trovaTermine(COLORI, testo);
    var disciplina = trovaTermine(DISCIPLINE, testo);
    var taglia = trovaTaglia(testo);

    // Un solo criterio riconosciuto non aggiunge nulla alla ricerca
    // testuale: la scorciatoia serve quando restringe davvero.
    var criteri = [colore, disciplina, taglia].filter(Boolean);
    if (criteri.length < 2) return;

    var params = [];
    var etichette = [];
    if (colore) {
      params.push('filter.p.m.custom.colore_base=' + encodeURIComponent(colore));
      etichette.push(colore.toLowerCase());
    }
    if (taglia) {
      // 2026-09-29: il filtro Taglia gira sulle taglie ACQUISTABILI (custom.taglie_disponibili).
      params.push('filter.p.m.custom.taglie_disponibili=' + encodeURIComponent(taglia));
      etichette.push(T.size + taglia);
    }
    if (disciplina) {
      params.push('filter.p.m.custom.disciplina=' + encodeURIComponent(disciplina));
      etichette.push(disciplina.toLowerCase());
    }

    var ancora =
      document.querySelector('.template-search__header') ||
      document.querySelector('.template-search__results') ||
      document.querySelector('#ProductGridContainer');
    if (!ancora) return;

    // Costruito nodo per nodo: nessuna stringa della query finisce in
    // innerHTML. Le etichette vengono comunque solo dalle mappe qui sopra e
    // dalle cifre validate, mai dal testo grezzo digitato.
    var box = document.createElement('div');
    box.className = 'wd-search-shortcut';

    var label = document.createElement('span');
    label.className = 'wd-search-shortcut__label';
    label.textContent = T.ask + etichette.join(' + ') + '?';

    var link = document.createElement('a');
    link.className = 'wd-search-shortcut__link';
    link.href = root.replace(/\/?$/, '/') + 'collections/all?' + params.join('&');
    link.textContent = T.see;

    var freccia = document.createElement('span');
    freccia.setAttribute('aria-hidden', 'true');
    freccia.textContent = '→';
    link.appendChild(freccia);

    box.appendChild(label);
    box.appendChild(link);
    ancora.parentNode.insertBefore(box, ancora);
  }

  /* ================================================================
     3. Taglie della scheda
     ----------------------------------------------------------------
     Il markup arriva gia dal Liquid. Qui si limita solo il numero di
     taglie mostrate quando lo spazio non basta, per non mandare la
     riga a capo e sfalsare la griglia.
     ================================================================ */
  // 2026-09-28: oltre al tetto fisso (5 su telefono, 7 su desktop) si tolgono
  // pastiglie finche' la riga entra nella scheda: prima il «+N» finiva fuori dal
  // riquadro in 259 schede su 260 e non si vedeva mai.
  function adattaTaglie() {
    document.querySelectorAll('.wd-card-sizes').forEach(function (box) {
      if (box.dataset.wdAdattato) return;
      if (!box.clientWidth) return; // non ancora impaginata: si riprova dopo
      box.dataset.wdAdattato = '1';
      var voci = Array.prototype.slice.call(box.querySelectorAll('.wd-card-sizes__item'));
      var totale = voci.length;
      var max = window.innerWidth < 750 ? 5 : 7;
      var tenute = Math.min(totale, max);
      for (var i = tenute; i < totale; i++) voci[i].remove();
      if (tenute === totale && box.scrollWidth <= box.clientWidth + 1) return;
      var piu = document.createElement('span');
      piu.className = 'wd-card-sizes__item wd-card-sizes__item--more';
      piu.textContent = '+' + (totale - tenute);
      box.appendChild(piu);
      while (tenute > 1 && box.scrollWidth > box.clientWidth + 1) {
        tenute--;
        voci[tenute].remove();
        piu.textContent = '+' + (totale - tenute);
      }
      if (tenute === totale) piu.remove();
    });
  }
  // Le griglie arrivano anche via AJAX (filtri, slider della home): si rifa'
  // la potatura quando compaiono schede nuove.
  if (window.MutationObserver) {
    var attesaTaglie = null;
    new MutationObserver(function () {
      clearTimeout(attesaTaglie);
      attesaTaglie = setTimeout(adattaTaglie, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* La descrizione della collezione su telefono la gestisce gia il tema:
     sections/main-collection-banner.liquid ritaglia a tre righe e mette il
     comando "Leggi tutto" con aria-expanded. Qui c'era un secondo comando
     identico, scritto senza accorgersene: rimosso. */

  /* ================================================================
     4. Il riquadro Google Merchant, su telefono
     ----------------------------------------------------------------
     L'app lo posiziona con stili in linea marcati !important
     (`bottom: 110px !important; left: 0 !important`): nessuna regola
     CSS puo spostarlo. Su 390x844 finiva sopra il pulsante "Scegli
     opzioni" della prima scheda. Qui si riscrive la proprieta con la
     stessa priorita, e si ricontrolla se l'app la rimette.
     ================================================================ */
  function spostaWidgetRecensioni() {
    if (window.innerWidth > 749) return;
    var w = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (!w) {
      // L'app inietta il riquadro dopo il caricamento: si attende che compaia,
      // per un tempo limitato, invece di sondare all'infinito.
      if (spostaWidgetRecensioni.inAttesa) return;
      spostaWidgetRecensioni.inAttesa = true;
      var attesa = new MutationObserver(function () {
        if (document.getElementById('google-merchantwidget-iframe-wrapper')) {
          attesa.disconnect();
          spostaWidgetRecensioni.inAttesa = false;
          spostaWidgetRecensioni();
        }
      });
      attesa.observe(document.body, { childList: true });
      setTimeout(function () { attesa.disconnect(); spostaWidgetRecensioni.inAttesa = false; }, 12000);
      return;
    }

    function posiziona() {
      // Sulla scheda prodotto la barra d'acquisto sta in fondo: sopra di essa.
      var conBarra = !!document.querySelector('.wd-stickybuy');
      w.style.setProperty('bottom', conBarra ? '72px' : '6px', 'important');
      w.style.setProperty('left', '6px', 'important');
      w.style.setProperty('transform', 'scale(0.7)', 'important');
      w.style.setProperty('transform-origin', 'bottom left', 'important');
    }

    posiziona();
    var mo = new MutationObserver(function () { posiziona(); });
    mo.observe(w, { attributes: true, attributeFilter: ['style'] });
  }

  /*
   * PDP, galleria a foto grande (2026-09-24). Da 750px la striscia di miniature
   * e' nascosta (CSS in wd-uxlab.css, «Galleria a foto grande») e si sfoglia con
   * due frecce sulla foto e i tasti freccia. Le frecce cliccano il
   * pulsante miniatura di Dawn: resta setActiveMedia a cambiare foto, quindi il
   * cambio variante continua a portare sulla foto giusta.
   */
  function galleriaFrecce() {
    document.querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]').forEach(function (gal) {
      if (gal.dataset.wdArrows) return;
      var viewer = gal.querySelector('[id^="GalleryViewer"]');
      var strip = gal.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer || !strip) return;
      var items = Array.prototype.slice.call(strip.querySelectorAll('.thumbnail-list__item[data-target]'));
      if (items.length < 2) return;
      gal.dataset.wdArrows = '1';
      gal.classList.add('wd-gal');

      // Etichette gia' tradotte: quelle dei pulsanti del cursore mobile di Dawn.
      var dawnPrev = viewer.querySelector('.slider-button--prev');
      var dawnNext = viewer.querySelector('.slider-button--next');
      var chevron = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
        '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      function button(dir, label) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wd-gal__arrow wd-gal__arrow--' + dir;
        b.setAttribute('aria-label', label);
        b.setAttribute('aria-controls', viewer.id);
        b.innerHTML = chevron;
        return b;
      }
      var prev = button('prev', (dawnPrev && dawnPrev.getAttribute('aria-label')) || 'Previous');
      var next = button('next', (dawnNext && dawnNext.getAttribute('aria-label')) || 'Next');
      viewer.appendChild(prev);
      viewer.appendChild(next);

      function current() {
        for (var i = 0; i < items.length; i++) {
          var btn = items[i].querySelector('button');
          if (btn && btn.getAttribute('aria-current') === 'true') return i;
        }
        return 0;
      }
      function go(step) {
        var i = (current() + step + items.length) % items.length;
        var btn = items[i].querySelector('button');
        if (btn) btn.click();
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      gal.addEventListener('keydown', function (e) {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        if (e.target.closest('input, textarea, select')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
    });
  }

  function init() {
    galleriaFrecce();
    suggerisciFiltri();
    adattaTaglie();
    spostaWidgetRecensioni();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Modale foto della PDP (galleria a tendina, 2026-09-28/29). Dawn chiude il
  // modale a ogni pointerup del mouse: va bene per un clic, non per un
  // trascinamento (barra di scorrimento, selezione, trascinamento che finisce sul
  // margine). Si lascia passare solo il pointerup di un clic vero: stesso punto
  // del pointerdown (entro 6 px) e non sulla barra di scorrimento.
  var modalDown = null;
  document.addEventListener('pointerdown', function (e) {
    modalDown = (e.pointerType === 'mouse' && e.target.closest && e.target.closest('product-modal[open]')) ? { x: e.clientX, y: e.clientY } : null;
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest || !e.target.closest('product-modal[open]')) return;
    var c = e.target.classList && e.target.classList.contains('product-media-modal__content') ? e.target : null;
    var suBarra = c && (e.offsetX >= c.clientWidth || e.offsetY >= c.clientHeight);
    var trascinato = !modalDown || Math.abs(e.clientX - modalDown.x) > 6 || Math.abs(e.clientY - modalDown.y) > 6;
    if (suBarra || trascinato) e.stopPropagation();
  }, true);

  // All'apertura: la foto cliccata e' un quadrato piu' alto dello schermo e Dawn
  // la porta in cima, quindi la scarpa usciva tagliata in basso. Si centra la
  // foto nello schermo. Alla chiusura Dawn rimette il focus sul pulsante della
  // foto (0x0, sotto l'immagine) e il browser scorreva la pagina di ~550 px: si
  // torna dov'eri.
  var yPrima = null;
  function modaleAperto(m) {
    yPrima = window.scrollY;
    setTimeout(function () {
      var c = m.querySelector('.product-media-modal__content');
      var a = c && c.querySelector('.active');
      if (!c || !a || a.offsetHeight <= c.clientHeight) return;
      c.scrollTop = a.offsetTop - (c.clientHeight - a.offsetHeight) / 2;
    }, 60);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { if (m.target.tagName === 'PRODUCT-MODAL' && m.target.hasAttribute('open')) modaleAperto(m.target); });
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  document.body && document.body.addEventListener('modalClosed', function () {
    if (yPrima === null) return;
    var y = yPrima; yPrima = null;
    setTimeout(function () { window.scrollTo(0, y); }, 0);
  });

  // La griglia si ricarica via AJAX a ogni filtro applicato.
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('popstate', function () { setTimeout(adattaTaglie, 300); });
})();

// UX pass 26/09: sulla PDP mobile la bolla WhatsApp copriva «Aggiungi al carrello».
// Finche' i pulsanti d'acquisto sono visibili, <html> prende .wd-buy-inview e il CSS
// nasconde la bolla; appena escono dallo schermo torna.
(function () {
  if (!('IntersectionObserver' in window)) return;
  function watch() {
    var el = document.querySelector('.product-form__buttons');
    if (!el || el.dataset.wdWatch) return;
    el.dataset.wdWatch = '1';
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('wd-buy-inview', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

// Banner cookie Pandectes: <pandectes-cmp> resta nel DOM anche dopo la scelta
// (stessi attributi), quindi si guarda se il suo shadow root disegna qualcosa.
// Finche' e' visibile <html> ha .wd-cookie-open e il CSS toglie le bolle chat.
(function () {
  var t0 = Date.now(), seen = false;
  function aperto() {
    var c = document.querySelector('pandectes-cmp');
    if (!c || !c.shadowRoot) return false;
    var els = c.shadowRoot.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().height > 40) return true;
    }
    return false;
  }
  // 2026-09-28: altezza della barra in --wd-cookie-h, cosi' il CSS alza sopra
  // di lei «Vai al pagamento» del drawer, la barra d'acquisto e la fine pagina.
  function altezza() {
    var c = document.querySelector('pandectes-cmp');
    if (!c || !c.shadowRoot) return 0;
    var d = c.shadowRoot.querySelector('dialog.bottom, .dialog.bottom, dialog[open]');
    if (!d) return 0;
    var r = d.getBoundingClientRect();
    if (r.height < 40 || r.bottom < window.innerHeight - 2 || r.top < window.innerHeight * 0.4) return 0;
    return Math.round(window.innerHeight - r.top);
  }
  var root = document.documentElement;
  var timer = setInterval(function () {
    var open = aperto();
    if (open) seen = true;
    root.classList.toggle('wd-cookie-open', open);
    var h = open ? altezza() : 0;
    if (h) root.style.setProperty('--wd-cookie-h', h + 'px'); else root.style.removeProperty('--wd-cookie-h');
    // Si smette di guardare quando il cliente ha scelto, o dopo 90 s se il banner
    // non e' mai comparso (consenso gia' dato). Prima si smetteva comunque a 90 s
    // e il drawer tornava sotto il banner ancora aperto.
    if ((seen && !open) || (!seen && Date.now() - t0 > 90000)) {
      root.classList.remove('wd-cookie-open');
      root.style.removeProperty('--wd-cookie-h');
      clearInterval(timer);
    }
  }, 600);
})();

/* Semplifica 2026-09-28 — i link «Guida alle taglie» / «Come pulire» della
   colonna PDP (wd-product-trust, data-wd-open) e le ancore #wd-size, #wd-care,
   #wd-spec, #wd-desc aprono il pannello di wd-product-description prima di
   scorrerci: un <details> chiuso non si apre da solo con l'ancora. */
(function apriPannelloDaAncora() {
  function apri(id, scorri) {
    var d = document.getElementById(id);
    if (!d || d.tagName !== 'DETAILS') return false;
    d.open = true;
    if (scorri) d.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    var s = d.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-wd-open]');
    if (!a) return;
    if (apri(a.getAttribute('data-wd-open'), true)) {
      e.preventDefault();
      history.replaceState(null, '', '#' + a.getAttribute('data-wd-open'));
    }
  });
  function daHash() {
    var id = location.hash.slice(1);
    if (/^wd-(size|care|spec|desc)$/.test(id)) apri(id, true);
  }
  window.addEventListener('hashchange', daHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', daHash); else daHash();
})();

/* Sprint vendita 2026-09-28 — SmartBot resta (decisione dell'utente), ma senza il
   fumetto che si apre da solo dopo ~10 s («Hai visto le scarpe donna?…»): su
   desktop restava 85 s sopra la colonna filtri e la sua striscia trasparente
   bloccava i clic su filtri e schede. Si nascondono fumetto, striscia e
   pallino «1» con uno stile dentro lo shadow root (open) dell'app; l'icona e la
   chat restano. Le classi hanno un hash che cambia con gli aggiornamenti
   dell'app: selettori per sottostringa; se cambiano, il fumetto torna e basta. */
(function smartBotSenzaFumetto() {
  var CSS = '[class*="_notification-card_"],[class*="_close-wrap_"],[class*="_chat-icon-badge_"]{display:none!important}';
  var t0 = Date.now();
  function inietta(root) {
    if (!root || root.querySelector('style[data-wd-nofumetto]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-wd-nofumetto', '');
    st.textContent = CSS;
    root.appendChild(st);
  }
  var timer = setInterval(function () {
    var host = document.getElementById('smart-bot-container');
    if (host && host.shadowRoot) {
      inietta(host.shadowRoot);
      host.shadowRoot.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) inietta(el.shadowRoot); });
    }
    if (Date.now() - t0 > 120000) clearInterval(timer);
  }, 700);
})();


/* Ricerca (2026-10-15): la riscrittura delle query sta in assets/wd-search-query.js (window.wdQuery).
   Qui: (1) all'invio di ogni form di ricerca la query diventa quella riscritta e il testo digitato va nel
   parametro wdq; (2) sulla pagina risultati la casella, i titoli e il <title> mostrano il testo digitato;
   (3) se non c'e' nessun risultato (solo italiano) un refuso viene corretto con il vocabolario del catalogo
   (assets/wd-search-vocab.json): «colant» -> «collant», con l'avviso sopra i risultati. */
(function () {
  function q2(v) { return window.wdQuery ? window.wdQuery(v) : v; }
  function show(v) { return window.wdQueryShow ? window.wdQueryShow(v) : v; }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var i = f.querySelector('input[name="q"]');
    if (!i || !i.value.trim()) return;
    // 2026-10-31: un solo percorso testo -> URL (wdRoute), lo stesso dei link diretti e della correzione dei refusi
    var d = window.wdRoute && window.wdRoute(i.value.trim());
    if (!d) return;
    e.preventDefault();
    location.href = d;
  }, true);

  var u = new URL(location.href), q = u.searchParams.get('q');
  if (q == null || !/\/search\/?$/.test(location.pathname)) return;
  var shown = show(q), wdq = (u.searchParams.get('wdq') || '').trim();
  var testo = wdq && q2(wdq) === q ? wdq : shown;
  function sostituisci(root) {
    if (!shown || testo === shown) return;
    var it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = it.nextNode())) if (n.nodeValue.indexOf(shown) >= 0) n.nodeValue = n.nodeValue.split(shown).join(testo);
  }
  function mostra() {
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (i.type === 'hidden') return;
      i.value = testo;   // il testo digitato, non la query riscritta ne' le entita' HTML
    });
    var m = document.getElementById('MainContent');
    if (m) sostituisci(m);
    if (testo !== shown) document.title = document.title.split(shown).join(testo);
    var fix = u.searchParams.get('wdc');
    if (fix && !document.querySelector('.wd-search-fix')) {
      var h = document.querySelector('.template-search__search');
      if (h) {
        var p = document.createElement('p');
        p.className = 'wd-search-fix';
        p.style.cssText = 'text-align:center;margin:0 auto 2.4rem;max-width:74rem';
        p.textContent = 'Nessun risultato per «' + fix + '». Ti mostriamo i risultati per «' + testo + '».';
        h.parentNode.insertBefore(p, h.nextSibling);
      }
    }
    correggi();
  }
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= b.length; i++) d[i] = i;
    for (i = 1; i <= a.length; i++) {
      var prev = d[0], lo = (d[0] = i);
      for (j = 1; j <= b.length; j++) {
        var t = d[j];
        d[j] = Math.min(d[j] + 1, d[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = t; if (d[j] < lo) lo = d[j];
      }
      if (lo > max) return max + 1;
    }
    return d[b.length];
  }
  function norm(v) { return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  // Nome modello: Shopify aggiunge i «quasi uguali» (Morgane -> anche Morgan). Se tutto sta in una pagina,
  // si tolgono le schede il cui titolo non contiene il nome e si correggono i contatori.
  function soloNome() {
    var S = window.wdSearch, nomi = (window.wdQuery && window.wdQuery.names) || '', n = norm(testo).trim();
    if (!S || !S.count || S.count > 24 || /\s/.test(n) || nomi.indexOf(',' + n + ',') < 0) return;
    var re = new RegExp('(^|[^a-z0-9])' + n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)'), tolti = 0;
    document.querySelectorAll('#product-grid [id^="CardLink"]').forEach(function (a) {
      if (re.test(norm(a.textContent))) return;
      var li = a.closest('li') || a.closest('.grid__item');
      if (li && li.style.display !== 'none') { li.style.display = 'none'; tolti++; }
    });
    if (!tolti) return;
    var da = String(S.count), a2 = String(S.count - tolti);
    function conta(root) {
      var it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), t;
      while ((t = it.nextNode())) if (/\d/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(new RegExp('\\b' + da + '\\b'), a2);
    }
    document.querySelectorAll('#ProductCount, #ProductCountDesktop, .template-search__header [role=status]').forEach(conta);
    document.title = document.title.replace(new RegExp('\\b' + da + '\\b'), a2);
  }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lang = ((window.Shopify && Shopify.locale) || 'it').slice(0, 2);
  // Rifà la ricerca con un altro testo passando dallo stesso percorso del form (filtri e collezioni compresi: prima la
  // correzione di «salsa domna» perdeva il filtro Salsa). orig = cio' che il cliente ha scritto, resta nell'avviso.
  function rifai(testo, orig, passo) {
    var d = (window.wdRoute && window.wdRoute(testo)) || (root + 'search?' + new URLSearchParams({ q: testo, 'options[prefix]': 'last', wdq: testo }));
    var v = new URL(d, location.origin);
    if (/\/search$/.test(v.pathname)) { v.searchParams.set('wdc', orig); if (passo) v.searchParams.set('wdr', passo); }
    else if (!v.searchParams.get('wdattr')) v.searchParams.set('wdattr', orig + '|' + testo);
    location.replace(v.toString());
  }
  // Ancora nessun risultato: categorie principali e WhatsApp con il testo cercato (IT/EN/ES).
  function vuoto() {
    var h = document.querySelector('.template-search__search');
    if (!h || document.querySelector('.wd-search-empty')) return;
    var TT = { it: ['Non trovi il modello che cerchi?', 'Scrivici su WhatsApp', 'Ciao, sul sito cerco «%s» e non lo trovo. Mi aiutate?', 'Oppure guarda:', ['Sandali da ballo', 'sandali-da-ballo'], ['Scarpe donna', 'donna'], ['Scarpe uomo', 'uomo'], ['Sneakers', 'sneakers']],
      en: ['Can’t find the model you’re looking for?', 'Message us on WhatsApp', 'Hi, I’m looking for «%s» on your website and can’t find it. Can you help?', 'Or browse:', ['Dance sandals', 'sandali-da-ballo'], ['Women’s shoes', 'donna'], ['Men’s shoes', 'uomo'], ['Sneakers', 'sneakers']],
      es: ['¿No encuentras el modelo que buscas?', 'Escríbenos por WhatsApp', 'Hola, busco «%s» en la web y no lo encuentro. ¿Me ayudáis?', 'O mira:', ['Sandalias de baile', 'sandali-da-ballo'], ['Zapatos de mujer', 'donna'], ['Zapatos de hombre', 'uomo'], ['Sneakers', 'sneakers']] }, T = TT[lang] || TT.en;
    var b = document.createElement('div'), p = document.createElement('p'), a = document.createElement('a'), c = document.createElement('p');
    b.className = 'wd-search-empty';
    b.style.cssText = 'text-align:center;margin:0 auto 3.2rem;max-width:74rem';
    p.textContent = T[0] + ' ';
    a.href = 'https://wa.me/393492315150?text=' + encodeURIComponent(T[2].replace('%s', (u.searchParams.get('wdc') || testo))); a.target = '_blank'; a.rel = 'noopener'; a.className = 'link'; a.textContent = T[1];
    p.appendChild(a);
    c.appendChild(document.createTextNode(T[3] + ' '));
    T.slice(4).forEach(function (x, k) {
      var l = document.createElement('a'); l.href = root + 'collections/' + x[1]; l.className = 'link'; l.textContent = x[0];
      if (k) c.appendChild(document.createTextNode(' · '));
      c.appendChild(l);
    });
    c.style.marginTop = '1.2rem';
    b.appendChild(p); b.appendChild(c);
    h.parentNode.insertBefore(b, h.nextSibling);
  }
  function correggi() {
    var S = window.wdSearch;
    if (!S || S.count !== 0) return;
    vuoto();
    if (!wdq || u.searchParams.get('wdp')) return;
    if (lang !== 'it') {
      // EN/ES: la riscrittura non ha trovato nulla -> una sola volta la ricerca normale di Shopify.
      if (q !== wdq) { var w = new URL(location.href); w.searchParams.set('q', wdq); w.searchParams.set('wdp', '1'); location.replace(w.toString()); }
      return;
    }
    var orig = u.searchParams.get('wdc') || wdq, passo = +(u.searchParams.get('wdr') || 0);
    if (passo >= 2) return;
    var nomi = (window.wdQuery && window.wdQuery.names) || '';
    var parole = (window.wdQueryParole ? window.wdQueryParole(wdq) : wdq.toLowerCase().split(/\s+/));
    var piene = parole.filter(function (w) { return !/^(a|ad|al|alla|da|di|del|della|per|in|con|e|ed|il|la|le|lo|i|gli|un|una)$/.test(w); });
    // 1) la parola e' il nome di una collezione («exclusive» -> Mocassini Exclusive): si va li'
    var primo = !u.searchParams.get('wdc') && !passo;
    var coll = primo ? fetch(root + 'search/suggest.json?q=' + encodeURIComponent(wdq) + '&resources[type]=collection&resources[limit]=4')
      .then(function (r) { return r.json(); }).then(function (j) {
        var cs = (((j || {}).resources || {}).results || {}).collections || [];
        return cs.filter(function (c) { var t = ' ' + norm(c.title).replace(/[^a-z0-9]+/g, ' ') + ' '; return piene.every(function (w) { return t.indexOf(' ' + norm(w) + ' ') >= 0; }); })[0];
      }).catch(function () { return null; }) : Promise.resolve(null);
    Promise.all([coll, fetch(S.vocab).then(function (r) { return r.json(); })]).then(function (res) {
      var c0 = res[0], V = res[1];
      if (c0) { var cu = new URL(new URL(c0.url, location.origin).pathname, location.origin); cu.searchParams.set('wdattr', wdq + '|' + c0.title); location.replace(cu.toString()); return; }
      if (primo) {
        // 2) refusi: parola fuori vocabolario -> la piu' vicina (corte: stessa iniziale; i nomi modello si propongono soltanto)
        var cambiato = false, nome = false;
        var nuove = parole.map(function (w) {
          var l = norm(w);
          if (l.length < 4 || /\d/.test(l) || V[l] || nomi.indexOf(',' + l + ',') >= 0) return w;
          var max = l.length >= 8 ? 2 : 1, best = null, bd = max + 1, bf = 0;
          for (var k in V) {
            if (k.charAt(0) === '_' || (l.length <= 5 && k.charAt(0) !== l.charAt(0))) continue;
            var dd = lev(l, k, max);
            if (dd < bd || (dd === bd && V[k] > bf)) { best = k; bd = dd; bf = V[k]; }
          }
          if (best && bd <= max) { cambiato = true; if (nomi.indexOf(',' + best + ',') >= 0) nome = true; return best; }
          return w;
        });
        if (cambiato) {
          var cc = nuove.join(' ');
          if (!nome) { rifai(cc, orig, 0); return; }
          // Un nome di modello non si sostituisce da solo (romina -> roxina sarebbe un altro prodotto): si propone.
          var h = document.querySelector('.template-search__search');
          if (!h || document.querySelector('.wd-search-fix')) return;
          var p = document.createElement('p'), a = document.createElement('a');
          p.className = 'wd-search-fix';
          p.style.cssText = 'text-align:center;margin:0 auto 2.4rem;max-width:74rem';
          a.href = (window.wdRoute && window.wdRoute(cc)) || (root + 'search?q=' + encodeURIComponent(cc)); a.textContent = cc; a.className = 'link';
          p.appendChild(document.createTextNode('Forse cercavi: '));
          p.appendChild(a);
          p.appendChild(document.createTextNode('?'));
          h.parentNode.insertBefore(p, h.nextSibling);
          return;
        }
        // 3) parole che sono attributi del catalogo ma non stanno nei titoli («verde», «microfibra»): collezione filtrata
        var A = V._attr || {}, filtri = [], pa = [];
        parole.forEach(function (w) { var x = A[norm(w)]; if (x) { filtri.push(x); pa.push(w); } });
        if (filtri.length && filtri.length === piene.filter(function (w) { return !/\d/.test(w); }).length) {
          var ca = new URL(root + 'collections/all', location.origin);
          filtri.forEach(function (x) { ca.searchParams.append('filter.p.m.custom.' + x[0], x[1]); });
          var sz = window.wdQuerySize && window.wdQuerySize(wdq);
          if (sz) ca.searchParams.append('filter.p.m.custom.taglie_disponibili', sz);
          ca.searchParams.set('wdattr', pa.join(' ') + '|' + filtri.map(function (x) { return x[1]; }).join(', '));
          location.replace(ca.toString());
          return;
        }
      }
      // 4) ripiego: via le parole che il catalogo non conosce («fascia t», «intrecciati»); se tutte note, via l'ultima
      if (piene.length < 2) return;
      var nota = (window.wdQuery && window.wdQuery.nota) || function () { return false; };
      var instrada = (window.wdQuery && window.wdQuery.instrada) || function () { return false; };
      var resto = piene.filter(function (w) { return /\d/.test(w) || V[norm(w)] || nota(w); });
      // tutte note: si tengono quelle che portano a una collezione o a un filtro, altrimenti via l'ultima
      if (resto.length === piene.length) { resto = piene.filter(instrada); if (!resto.length || resto.length === piene.length) resto = piene.slice(0, -1); }
      if (resto.length) rifai(resto.join(' '), orig, passo + 1);
    }).catch(function () {});
  }
  function avvio() { mostra(); soloNome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvio); else avvio();
})();

/* Ricerca -> collezione filtrata (2026-10-15): avviso sopra la griglia quando si arriva da una ricerca
   senza risultati la cui parola e' un attributo del catalogo (parametro wdattr = "parole|valori"). */
(function () {
  var v = new URL(location.href).searchParams.get('wdattr');
  if (!v || v.indexOf('|') < 0) return;
  function mostra() {
    var g = document.querySelector('#ProductGridContainer, .product-grid-container, #product-grid');
    if (!g || document.querySelector('.wd-search-fix')) return;
    var parti = v.split('|'), p = document.createElement('p');
    p.className = 'wd-search-fix';
    p.style.cssText = 'text-align:center;margin:0 auto 2.4rem;max-width:74rem';
    var it = ((window.Shopify && Shopify.locale) || 'it').slice(0, 2);
    p.textContent = it === 'en' ? 'Results for «' + parti[0] + '»: ' + parti[1] + '.'
      : it === 'es' ? 'Resultados para «' + parti[0] + '»: ' + parti[1] + '.'
      : 'Risultati per «' + parti[0] + '»: ' + parti[1] + '.';
    g.parentNode.insertBefore(p, g);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mostra); else mostra();
})();
